import { SelectorItem } from '../../components/Selector';
import { ISkipGlobalInputsParam } from '../SkipGlobalInputsParam';
import { ITimeout } from '../../timeout';
import {
  IParseAllMessage,
  IParseAttachments,
  IParseTextBase
} from '../../parsing';
import {
  BlockKind,
  BlockType,
  BlockBaseNormalized,
  BlockNormalizer
} from '../common';

import { ActionUserInputServer } from './server';

export interface IActionUserInputExtraction {
  text: IActionUserInputParseText;
  attachments: IParseAttachments | null;
}

export interface IActionUserInputParams {
  timeout: ITimeout | null;
  waitMessage: boolean;
  extraction: IActionUserInputExtraction;
  skipGlobalInputs: ISkipGlobalInputsParam;
}

export type ActionUserInputNormalized = BlockBaseNormalized<
  BlockType.action,
  BlockKind.userInput
>;

export type ActionUserInputNormalizer = BlockNormalizer<
  ActionUserInputServer,
  ActionUserInputNormalized
>;

export enum ActionUserInputParseTextType {
  allMessage = 'allMessage',
  pattern = 'pattern'
}

export const actionUserInputParseTextEntities: Record<
  ActionUserInputParseTextType,
  SelectorItem
> = {
  [ActionUserInputParseTextType.allMessage]: {
    id: ActionUserInputParseTextType.allMessage,
    title: (t) =>
      t('block.ActionUserInput.actionUserInputParseTextEntities.allMessage', {
        ns: 'entities'
      })
  },
  [ActionUserInputParseTextType.pattern]: {
    id: ActionUserInputParseTextType.pattern,
    title: (t) =>
      t(
        'block.ActionUserInput.actionUserInputParseTextEntities.pattern.title',
        {
          ns: 'entities'
        }
      ),
    reference: {
      content: (t) =>
        t(
          'block.ActionUserInput.actionUserInputParseTextEntities.pattern.ref',
          {
            ns: 'entities'
          }
        )
    }
  }
};

export interface IActionUserInputParseText {
  kind: ActionUserInputParseTextType;
  pattern: IParseTextBase;
  allMessageModel: IParseAllMessage;
}
